import types from "cms/enums/contentsTypes.enum";
export var fileImage = {
    label: "Choisir une image",
    type: types.FILE_IMAGE
};
